import { connect, ConnectedProps } from 'react-redux';

import { RootState } from 'src/redux/store';
import {
  selectors as individualDashboardSelectors,
  actions as individualDashboardActions,
} from 'src/routes/IndividualDashboard/modules/dashboard/slice';

const mapStateToProps = (state: RootState) => {
  const monitoringDaysData =
    individualDashboardSelectors.selectMonitoringDays(state);

  return {
    isLoading:
      individualDashboardSelectors.selectIsMonitoringDaysLoading(state),
    patientId: individualDashboardSelectors.getCurrentPatientId(state),
    monitoringDaysCount: monitoringDaysData?.monitoredDaysCount,
    totalDays: monitoringDaysData?.totalDays,
    trend: monitoringDaysData?.trend || 0,
  };
};

const mapActionCreators = {
  getMonitoringDaysData: individualDashboardActions.getMonitoringDaysData,
};

const Connector = connect(mapStateToProps, mapActionCreators);

export type PropsFromRedux = ConnectedProps<typeof Connector>;
export default Connector;
